import script from "./ShisetsuHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ShisetsuHome.vue?vue&type=script&setup=true&lang=js"

import "./ShisetsuHome.vue?vue&type=style&index=0&id=b5c3597e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5c3597e"]])

export default __exports__